module.exports = __webpack_public_path__ + "assets/img/capabilities_img2.14097054.png";